import React from 'react';
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

import {
  AdvancedThreatIconSvg,
  AlarmIconSvg,
  CveIconSvg,
  DataProtectIconSvg,
  ExploitIconSvg,
  HyperDetectIconSvg,
  LinkIconSvg,
  MalwareIconSvg,
  NetworkAttackIconSvg,
  RansomwareIconSvg,
  StarOutlinedSvg,
  StarSolidSvg,
  StorageMalwareIconSvg,
  TaskIconSvg,
  TaskListIconSvg,
  TaskMilestoneIconSvg,
  TeamFilledSvg,
  TicketTypeChangeRequestSvg,
  TicketTypeIncidentSvg,
  TicketTypeProblemSvg,
  TicketTypeProjectSvg,
  TicketTypeServiceRequestSvg,
} from '@totem/styles/svgIcons';

type CustomIconComponentProps = GetProps<typeof Icon>;
type CustomIconProps = Partial<Omit<CustomIconComponentProps, 'ref'>>;

// forwardRef so the icons work as direct children of Tooltip / Popover /
// Dropdown, which attach a ref to their child to position and trigger
const createIcon = (
  svg: CustomIconComponentProps['component'],
  displayName: string,
) => {
  const CustomIcon = React.forwardRef<HTMLSpanElement, CustomIconProps>(
    (props, ref) => (
      // @ts-ignore -- Icon's typings reject the react-css-modules styleName prop
      <Icon component={svg} ref={ref} {...props} />
    ),
  );
  CustomIcon.displayName = displayName;
  return CustomIcon;
};

export const MalwareIcon = createIcon(MalwareIconSvg, 'MalwareIcon');
export const NetworkAttackIcon = createIcon(
  NetworkAttackIconSvg,
  'NetworkAttackIcon',
);
export const RansomwareIcon = createIcon(RansomwareIconSvg, 'RansomwareIcon');
export const StorageMalwareIcon = createIcon(
  StorageMalwareIconSvg,
  'StorageMalwareIcon',
);
export const HyperDetectIcon = createIcon(
  HyperDetectIconSvg,
  'HyperDetectIcon',
);
export const DataProtectIcon = createIcon(
  DataProtectIconSvg,
  'DataProtectIcon',
);
export const ExploitIcon = createIcon(ExploitIconSvg, 'ExploitIcon');
export const AdvancedThreatIcon = createIcon(
  AdvancedThreatIconSvg,
  'AdvancedThreatIcon',
);
export const AlarmIcon = createIcon(AlarmIconSvg, 'AlarmIcon');
export const CveIcon = createIcon(CveIconSvg, 'CveIcon');
export const StarOutlinedIcon = createIcon(StarOutlinedSvg, 'StarOutlinedIcon');
export const StarSolidIcon = createIcon(StarSolidSvg, 'StarSolidIcon');
export const TicketTypeChangeRequest = createIcon(
  TicketTypeChangeRequestSvg,
  'TicketTypeChangeRequest',
);
export const TicketTypeIncident = createIcon(
  TicketTypeIncidentSvg,
  'TicketTypeIncident',
);
export const TicketTypeProblem = createIcon(
  TicketTypeProblemSvg,
  'TicketTypeProblem',
);
export const TicketTypeProject = createIcon(
  TicketTypeProjectSvg,
  'TicketTypeProject',
);
export const TicketTypeServiceRequest = createIcon(
  TicketTypeServiceRequestSvg,
  'TicketTypeServiceRequest',
);
export const TaskIcon = createIcon(TaskIconSvg, 'TaskIcon');
export const TaskListIcon = createIcon(TaskListIconSvg, 'TaskListIcon');
export const TaskMilestoneIcon = createIcon(
  TaskMilestoneIconSvg,
  'TaskMilestoneIcon',
);
export const TeamFilled = createIcon(TeamFilledSvg, 'TeamFilled');
export const LinkIcon = createIcon(LinkIconSvg, 'LinkIcon');
